module.exports = __webpack_public_path__ + "static/media/blur.bab56507.jpg";